import {ConfigConstant} from './config';
const routes = {
  LOGIN: ConfigConstant.PLATFORM_URL,
  HOME: '/',
  FAILED_ORDERS: '/order/failures',
  FAILED_ORDER_REPORT: '/order/report',
  OPS_RAW: '/ops/raw',
  OPS_CONSOLIDATED: '/ops/consolidated',
  OUTLETS: '/outlets/directory',
  BULK_OUTLET_SYNC: '/outlets/sync-bulk',
  OPS_REPORT: '/ops/report',
  ADMIN: '/admin',
};

export default routes;

const SearchParamConstant = {
  EDIT_TYPE: 'editType',
};

export {SearchParamConstant};
